import { render, staticRenderFns } from "./InvoicesForm.vue?vue&type=template&id=02653d1d&"
import script from "./InvoicesForm.vue?vue&type=script&lang=js&"
export * from "./InvoicesForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesForm.vue?vue&type=style&index=0&id=02653d1d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports